import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ISiteContent} from "../../models/SiteContent";

interface SiteContentState {
    content: ISiteContent;
    contentLoading: boolean;
}
const initialState: SiteContentState = {
    content: {
        loginBackgroundPath: null,
        language: "en",
        aboutUsBackgroundPath: null,
        aboutUsTitle: "",
        aboutUsDescription: "",
        heroTitle: "",
        heroBackgroundPath: null,
        heroDescription: "",
        primaryButtonText: "",
        secondaryButtonText: "",
        venuesVisible: false,
        venuesDescription: "",
        venuesItems: null,
        trainersVisible: false,
        trainersDescription: "",
        trainersItems: null,
        servicesVisible: false,
        servicesDescription: "",
        servicesItems: null,
        plansVisible: false,
        plansDescription: "",
        plansOrder: "",
        plansItems: [],
        mobileAppVisible: false,
        mobileAppImage: null,
        mobileAppTitle: "",
        mobileAppDescription: "",
        mobileAppGoogleLink: "#",
        mobileAppAppStoreLink: "#",
        faqVisible: false,
        faqItems: null,
        getItTouchVisible: false,
        getItTouchInstagramLink: "#",
        getItTouchGmailLink: "#",
        getItTouchFacebookLink: "#",
        getItTouchPhoneNumber: "#",
        plansItemsForPlansPage: [],
        contactUsFacebookLink: "",
        contactUsGmailLink: "",
        contactUsInstagramLink: "",
        contactUsPhoneNumber: "",
    },
    contentLoading: true,
}

export const siteContentSlice = createSlice({
    name: "site-content",
    initialState,
    reducers: {
        setSiteContent: (state, action: PayloadAction<ISiteContent>) => {
            state.content = action.payload;
            state.contentLoading = false;
        }
    },

})

export const {setSiteContent} = siteContentSlice.actions;

export default siteContentSlice.reducer;